<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Edit Activity Template

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-8px"><span>*</span>Protocol</label>
                      </div>

                      <div class="col-md-6">
                        <CodeTypeValue CodeType="TRPRO"
                                       id="CurrentEditIvfPlanTemplateRequest.Protocol"
                                       [(ngModel)]="CurrentEditIvfPlanTemplateRequest.Protocol" SelectedValue="CurrentEditIvfPlanTemplateRequest.Protocol"
                                       name="CurrentEditIvfPlanTemplateRequest.Protocol" required>
                        </CodeTypeValue>


                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-8px"><span>*</span>Cycle</label>
                      </div>

                      <div class="col-md-6">
                        <CodeTypeValue CodeType="IVFTT"
                                       id="CurrentEditIvfPlanTemplateRequest.CycleType"
                                       [(ngModel)]="CurrentEditIvfPlanTemplateRequest.CycleType" SelectedValue="CurrentEditIvfPlanTemplateRequest.CycleType"
                                       name="CurrentEditIvfPlanTemplateRequest.CycleType" required>
                        </CodeTypeValue>


                      </div>
                    </div>


                  </div>
                </div>


              </div>
            </div>


            <!--<div class="card-footer text-align-center">
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
            </div>-->


















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
